import React from "react";
import { Upload, Form, Input, Avatar } from "antd";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import agent from "agent";

const FormItem = Form.Item;

function getBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}

class UploadCompanyImg extends React.Component {
    constructor(props) {
        super(props);
    }

    static propTypes = {
        form: PropTypes.object.isRequired,
        onRef: PropTypes.func.isRequired,

        handleImageVal: PropTypes.func.isRequired,
    };

    state = {
        fileList: [],
    };

    companyImgCheck = async () => {
        return new Promise((resolve, reject) => {
            this.props.form.validateFields((err, values) => {
                if (!err) {
                    console.log("Received values of form: ", values);

                    this.props.handleImageVal({
                        licenseFrontImg: this.state.fileList[0],
                    });
                    return resolve(values);
                }
                return reject(err);
            });
        });
    };

    handleDeleteAvatarClick = e => {
        e.preventDefault();
        e.stopPropagation();
        this.props.form.setFields({
            imgPreviewInfo: {
                value: "",
            },
        });
        this.setState(state => ({
            fileList: [],
        }));
    };

    componentDidMount() {
        this.props.onRef(this);
    }

    render() {
        const { fileList } = this.state;

        const { getFieldDecorator, getFieldValue } = this.props.form;
        const uploadProps = {
            onRemove: file => {
                this.setState(state => {
                    return {
                        fileList: [],
                    };
                });
                this.props.form.setFields({
                    imgPreviewInfo: {
                        value: "",
                    },
                });
            },
            beforeUpload: file => {
                this.setState(state => ({
                    fileList: [file],
                }));

                getBase64(file).then(data => {
                    this.props.form.setFields({
                        imgPreviewInfo: {
                            value: data,
                        },
                    });
                });

                return false;
            },
            accept: "image/*",
            listType: "picture",
            showUploadList: false,
            fileList,
        };

        return (
            <Form>
                <div className="buypageForm__item">
                    <dl className="buypageForm__dl">
                        <dt className="buypageForm__dt u-alsT">
                            <label>营业执照照片</label>
                        </dt>
                        <dd className="buypageForm__dd">
                            <div className="form__columnBox">
                                <div className="form__columnBox__drop">
                                    <div className="form__dropBox form__dropBox--s">
                                        <div className="form__dropBox__inner">
                                            <p className="form__dropBox__txt">
                                                证件正面
                                            </p>
                                            <div className="form__dropBox__img">
                                                <img
                                                    src="/assets/img/id-photo_04.png"
                                                    alt=""
                                                />
                                            </div>
                                            <div className="form__dropBox__btn">
                                                <Upload {...uploadProps}>
                                                    <div className="m-btn-type0--s">
                                                        点击上传
                                                    </div>
                                                </Upload>
                                            </div>
                                        </div>
                                    </div>
                                    <FormItem>
                                        {getFieldDecorator("imgPreviewInfo", {
                                            rules: [
                                                {
                                                    required: true,
                                                    message:
                                                        "请上传营业执照照片!",
                                                },
                                            ],
                                        })(<Input type="hidden" />)}
                                    </FormItem>
                                    <p className="buypageForm__note">
                                        *请上传 2M 以内, JPG/RNG图片
                                    </p>
                                </div>
                                <div className="form__sampleImg">
                                    <div className="form__sampleImg__inner">
                                        <div>
                                            <Avatar
                                                key={getFieldValue(
                                                    "imgPreviewInfo"
                                                )}
                                                size={64}
                                                // icon="user"
                                                src={agent.getApiUrl(
                                                    getFieldValue(
                                                        "imgPreviewInfo"
                                                    )
                                                )}
                                            />
                                        </div>
                                        <div>
                                            {fileList.length == 0 ? (
                                                <img
                                                    src="/assets/img/img_license_sample.jpg"
                                                    alt=""
                                                    style={{ width: "100%" }}
                                                />
                                            ) : (
                                                <Link
                                                    // style={{
                                                    //     display: "block",
                                                    // }}
                                                    to="#"
                                                    onClick={
                                                        this
                                                            .handleDeleteAvatarClick
                                                    }
                                                >
                                                    删除图片
                                                </Link>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </dd>
                    </dl>
                </div>
            </Form>
        );
    }
}
const UploadCompanyImgForm = Form.create()(UploadCompanyImg);
export default connect()(UploadCompanyImgForm);
